import axios from 'axios';
import URLS from '../../util/urls.js';

const state = {
  contratos: []
}

const mutations = {
  atualizarContratos(state, payload) {
    state.contratos = payload;

    state.contratos = state.contratos.map(contrato => {
      return contrato.aluguel
        ? { ...contrato.aluguel, tipoContrato: contrato.tipoContrato }
        : { ...contrato.venda, tipoContrato: contrato.tipoContrato };
    });

    state.contratos = state.contratos.map(contrato => {
      return { ...contrato, selecionado: false };
    });
  },

  selecionarTodos(state) {
    state.contratos = state.contratos.map(contrato => {
      return { ...contrato, selecionado: true };
    });
  },
  deselecionarTodos(state) {
    state.contratos = state.contratos.map(contrato => {
      return { ...contrato, selecionado: false };
    });
  },
}

const actions = {
  listarProprietarios(context, payload) {
    return axios.post(URLS.EXTRATOS_DIMOB_LISTAR_PROPRIETARIOS, payload)
    .then((response) => {
      switch(response.data.status) {
        case "SUCESSO":
          context.commit('atualizarContratos', response.data.lista);
          return response.data;
        case "SESSAO_EXPIRADA":
          return context.dispatch('loginStore/relogar', {}, { root: true })
          .then(authResponse => {
            if(authResponse.status == "SUCESSO") {
              return context.dispatch('listarProprietarios', payload);
            }
          }).catch((error) => {
            throw error;
          });
        default:
          return response.data;
      }
    }).catch((error) => {
      throw error;
    });
  },

  gerarEtiquetas(context, payload) {
    return context.dispatch('loginStore/relogar', {}, { root: true })
    .then(authResponse => {
      if(authResponse.status == "SUCESSO") {
        return axios.post(URLS.EXTRATOS_DIMOB_GERAR_ETIQUETAS, payload, { responseType: 'blob' })
        .then((response) => {
          return response
        }).catch((error) => {
          throw error;
        });
      }
    }).catch((error) => {
      throw error;
    });
  },

  gerarExtratos(context, payload) {
    return context.dispatch('loginStore/relogar', {}, { root: true })
    .then(authResponse => {
      if(authResponse.status == "SUCESSO") {
        return axios.post(URLS.EXTRATOS_DIMOB_GERAR_EXTRATOS, payload, { responseType: 'blob' })
        .then((response) => {
          return response
        }).catch((error) => {
          throw error;
        });
      }
    }).catch((error) => {
      throw error;
    });
  },

  gerarArquivoImportacao(context, payload) {
    return context.dispatch('loginStore/relogar', {}, { root: true })
    .then(authResponse => {
      if(authResponse.status == "SUCESSO") {
        return axios.post(URLS.EXTRATOS_DIMOB_GERAR_ARQUIVO_IMPORTACAO, payload)
          .then((response) => {
            return response
          }).catch((error) => {
            throw error;
          });
      }
    }).catch((error) => {
      throw error;
    });
  },

  enviarExtratosEmail(context, payload) {
    return axios.post(URLS.EXTRATOS_DIMOB_ENVIAR_EXTRATOS, payload)
    .then(response => {
      switch (response.data.status) {
        case"SUCESSO":
          return response.data;
        case "SESSAO_EXPIRADA":
          return context.dispatch('loginStore/relogar', {}, {root: true  })
          .then(authResponse => {
            if(authResponse.status == 'SUCESSO') {
              return context.dispatch('enviarExtratosEmail', payload);
            }
          }).catch(error => {
            throw error;
          });
        default:
          return response.data;
      }
    }).catch(error => {
      throw error;
    })
  },

  selecionarTodos(context) {
    context.commit('selecionarTodos');
  },
  deselecionarTodos(context) {
    context.commit('deselecionarTodos');
  }
}

export default {
  state,
  mutations,
  actions
}